var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 8,
  height: 8,
  viewBox: "0 0 8 8"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Path_107",
  "data-name": "Path 107",
  d: "M0,8,8,0H0Z",
  transform: "translate(0 8) rotate(-90)",
  fill: "#fff5ea"
})));
export default __webpack_public_path__ + "static/media/left-icon.1731aea8.svg";
export { SvgComponent as ReactComponent };